import { render, staticRenderFns } from "./StatusesFilter.vue?vue&type=template&id=ba121ca8&scoped=true&"
import script from "./StatusesFilter.vue?vue&type=script&lang=js&"
export * from "./StatusesFilter.vue?vue&type=script&lang=js&"
import style0 from "./StatusesFilter.vue?vue&type=style&index=0&id=ba121ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba121ca8",
  null
  
)

export default component.exports